import React from "react"

import { useTranslation } from "react-i18next"

import { PromoCodeUsage } from "services/bonus/type"

import { formatDateTime } from "util/formatter"

interface Props {
  redemption: PromoCodeUsage
}

export const RedemptionCard = ({ redemption }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const statusColors: Record<string, string> = {
    ACTIVE: "bg-blue-600",
    COMPLETED: "bg-emerald-600"
  }

  return (
    <div className="bg-[#0C0C1A] rounded-lg p-4">
      <div className="flex justify-between items-start mb-2">
        <div>
          <div className="text-white font-medium">{redemption.user?.display_name || redemption.user?.username || "Anonymous"}</div>
          <div className="text-gray-400 text-sm">{redemption.user?.email_address || redemption.user_id}</div>
        </div>
        <span className={`px-2 py-1 text-xs rounded ${statusColors[redemption.status] || "bg-gray-600"}`}>{redemption.status}</span>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div>
          <span className="text-gray-500">{t("bonus2.promo.totalDeposits")}</span>{" "}
          <span className="text-white">${((redemption.user?.total_deposit_amount ?? 0) / 100).toFixed(2)}</span>
        </div>
        <div>
          <span className="text-gray-500">{t("bonus2.promo.redeemed")}</span> <span className="text-white">{formatDateTime(redemption.created_at)}</span>
        </div>
      </div>
      {redemption.wagering_requirement > 0 && (
        <div className="mt-2 pt-2 border-t border-gray-700">
          <div className="flex justify-between text-xs">
            <span className="text-gray-500">{t("bonus2.promo.wageringProgress")}</span>
            <span className="text-white">
              ${(Number(redemption.wagering_completed) / 100).toFixed(2)} / ${(Number(redemption.wagering_requirement) / 100).toFixed(2)}
            </span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-1.5 mt-1">
            <div
              className="bg-purple-600 h-1.5 rounded-full"
              style={{
                width: `${Math.min(100, (Number(redemption.wagering_completed) / Number(redemption.wagering_requirement)) * 100)}%`
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
